import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';
import {
	GET_SUBCATEGORIES, CREATE_SUBCATEGORIES, UPDATE_SUBCATEGORIES, GET_ERRORS, GET_SUBCATEGORIESPAG, DEACTIVATE_SUBCATEGORIES, ACTIVATE_SUBCATEGORIES
} from './types';

const URL_GETSUBCATEGORIES         = process.env.REACT_APP_API_URL + services.getSubcategories;
const URL_GETSUBCATEGORIESPAG      = process.env.REACT_APP_API_URL + services.getSubcategoriesPag;
const URL_ADDSUBCATEGORIES         = process.env.REACT_APP_API_URL + services.addSubcategories;
const URL_PATCH_SUBCATEGORIES      = process.env.REACT_APP_API_URL + services.updateSubcategories;
const URL_DEACTIVATE_SUBCATEGORIES = process.env.REACT_APP_API_URL + services.deactivateSubcategories;  
const URL_ACTIVATE_SUBCATEGORIES   = process.env.REACT_APP_API_URL + services.activateSubcategories;

export const getSubcategoriesToSelect = () => dispatch => {
	axios
		.post(URL_GETSUBCATEGORIES)
		.then(res => {
			dispatch({
				type: GET_SUBCATEGORIES,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const getSubcategoriesPag = (page, search) => dispatch => {
	let url = URL_GETSUBCATEGORIESPAG + '?limit=6&page=' + page
	if (search)
		url += '&name=' + search

	axios
		.get(url)
		.then(res => {
			dispatch({
				type: GET_SUBCATEGORIESPAG,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const createSubcategories = (name, img_b64, extension, subcategories) => dispatch => {
	const data = {
		'subcategory': {
			'name': name,
			'subcategories': subcategories,
			'img_b64': img_b64,
			'extension': extension
		}
	}
	axios.post(URL_ADDSUBCATEGORIES, data)
		.then(res => {
			dispatch({
				type: CREATE_SUBCATEGORIES,
				payload: {
					message: res.data
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const updateSubcategories = (id, name, img_b64, extension, subcategories) => dispatch => {
	const data = {
		'subcategory': {
			'id': id,
			'name': name,
			'subcategories': subcategories,
			'img_b64': img_b64,
			'extension': extension
		}
	}

	axios.put(URL_PATCH_SUBCATEGORIES, data)
		.then(res => {
			dispatch({
				type: UPDATE_SUBCATEGORIES,
				payload: {
					message: res.data
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deactivateSubcategories = (id) => dispatch => {

	let url = URL_DEACTIVATE_SUBCATEGORIES + id;

	axios.delete(url)
		.then(res => {
			dispatch({
				type: DEACTIVATE_SUBCATEGORIES,
				payload: {
					message: res.data
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const activateSubcategories = (id) => dispatch => {

	let url = URL_ACTIVATE_SUBCATEGORIES + id;

	axios.put(url)
		.then(res => {
			dispatch({
				type: ACTIVATE_SUBCATEGORIES,
				payload: {
					message: res.data
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}